import { HttpClient } from '@angular/common/http';
import { inject, Injectable, OnDestroy } from '@angular/core';
import { environment } from '@env/environment';
import { Observable, Subscription, throwError, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { AccessData, AccountItem } from '../models/accessData.model';

@Injectable({ providedIn: 'root' })
export class TokenGS1Service implements OnDestroy {
  __URL_API__ = `${environment.URL_API}`;

  private _http = inject(HttpClient);

  selectedCompany: AccountItem;
  subs: Subscription[] = [];
  s;
  ngOnDestroy(): void {
    this.subs.forEach((sub) => sub.unsubscribe());
  }

  getTokenGS1Admin(): Observable<string> {
    return this._http.get<string>(this.__URL_API__ + 'api/GS1Token/GetTokenAdmin').pipe(
      tap((tokenGS1) => localStorage.setItem('tokenGS1Admin', tokenGS1)),
      catchError(() => of(''))
    );
  }

  public handleError(error: any): Promise<any> {
    console.error(error);
    return Promise.reject(error.message || error);
  }
}
